import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  getUser, saveTokens,
  saveUser, clearTokens, isLoggedIn
} from '../utils/tokenHelper';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isLoggedIn()) {
      setUser(getUser());
    }
    setLoading(false);
  }, []);

  // LoginResponse is flat: { accessToken, refreshToken, userId, fullName, centerCode, ... }
  // Also supports nested: { accessToken, refreshToken, user: {...} }
  const loginSuccess = (data) => {
    const accessToken  = data.accessToken  || data.access_token  || '';
    const refreshToken = data.refreshToken || data.refresh_token || '';
    saveTokens(accessToken, refreshToken);

    // Build user object — handle both flat and nested response
    const user = data.user ?? {
      userId:       data.userId,
      fullName:     data.fullName,
      mobileNumber: data.mobileNumber,
      roleCode:     data.roleCode,
      centerId:     data.centerId,
      centerCode:   data.centerCode,
      centerName:   data.centerName,
      planCode:     data.planCode,
      langCode:     data.langCode,
    };
    saveUser(user);
    setUser(user);
  };

  const logoutUser = () => {
    clearTokens();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginSuccess, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
